import * as React from 'react';
import { useZustand } from 'use-zustand';
import { pathwayStore } from '../store';
import Breadcrumbs from '../../Breadcrumbs';
import Progress from './Progress';
import UserState from './UserState';
import { Code } from "react-content-loader";

function EstimatedTime(props) {
  const {time} = props;
  if (!time) {
    return null;
  }

  return (
    <p className='p--medium mb-0 estimated-time'><b>{time}</b></p>
  );
}

export default function Header(props) {
  const {
    title = '',
    text = '',
    estimatedTime = '',
  } = props;

  const {
    breadcrumbs,
  } = useZustand(pathwayStore, (state) => {
    return {
      breadcrumbs: state.breadcrumbs,
    }
  });

  return (
    <div className='nv-contextual-hero-banner nv-contextual-hero-banner--with-sidebar topic-area nv-learning-pathway-header'>
      <div className='container'>
        <div className='row row-override'>
          <div className='nv-contextual-hero-banner__main'>
            <Breadcrumbs items={breadcrumbs}/>
            <h1 className='h--large'>{title}</h1>
            <p className='p--large mb-3' dangerouslySetInnerHTML={{__html: text}}></p>
            <EstimatedTime time={estimatedTime}/>
          </div>
          <div className='nv-contextual-hero-banner__sidebar'>
            <Progress/>
            <UserState/>
          </div>
        </div>
      </div>
    </div>
  );
}

export function HeaderPreloader(props) {
  const {
    title = '',
    estimatedTime = '',
  } = props;
  return (
    <div className='nv-contextual-hero-banner nv-contextual-hero-banner--with-sidebar topic-area nv-learning-pathway-header'>
      <div className='container'>
        <div className='row row-override'>
          <div className='nv-contextual-hero-banner__main'>
            <Breadcrumbs items={[]}/>
            <h1 className='h--large'>{title}</h1>
            <div className='mt-2 mb-2' style={{width: 300}}>
              <div className='mb-2'><Code/></div>
              <div className='mb-2'><Code/></div>
            </div>
            <EstimatedTime time={estimatedTime}/>
          </div>
          <div className='nv-contextual-hero-banner__sidebar'>
            <Progress/>
            <UserState/>
          </div>
        </div>
      </div>
    </div>
  )
}
